export function isGamesTheme(): boolean {
	return (
		WEBPACK_PUBLIC_THEME === "twde-games" ||
		WEBPACK_PUBLIC_THEME === "twde-games-mobile"
	);
}
